/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './Card.style';

type Props = {
  layoutClass?: string,
  children?: React.Node,
  isDisabled?: boolean,
  isFaded?: boolean,
  // Self passed
};

const useStyles = createUseStyles(styles);

const Card = ({
  layoutClass,
  children,
  isFaded,
  isDisabled,
}: Props): React.Node => {
  const classes: Object = useStyles();

  // Classes

  const rootClasses = classNames(classes.root, layoutClass, {
    [classes['root-isFaded']]: isFaded,
    [classes['root-isDisabled']]: isDisabled,
  });

  return <div className={rootClasses}>{children}</div>;
};

export default Card;
